export interface FileExcel {
    customerCode?: string;
    countryCode?: string;
    blobDocumentID?: number;
    blobDocumentAuxID?: number;
    serviceCode?: number;
    serviceURL?: string;
    error?: string;
    referenceDateObj?: string;
    uploadDateObj?: string;
    dateStartObj?: Date;
    referenceDate?: string;
    uploadDate?: string;
    dateStart?: string;
    cemexReferenceType?: string;
    documentSearchDesc?: string;
    dateEndObj?: Date;
    dateEnd?: string;
    checked?: boolean;
    documentTypeCode?: number;
    documentTypeDesc?: string;
    customerReference?: string;
    cemexReference?: string;
    serviceParam?: string;
    isLoading?: boolean;
}

export interface FileList {
    files?: Array<FileExcel>;
    lienReleases?: Array<any>;
}
